import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CrudbarComponent, MaterialModule } from 'jk-service';
import { PageKind, UiModeType, entityState, } from 'jk-service';
import { JcktlEditComponent } from '../jcktl-edit/jcktl-edit.component';
//import { JcktlTabEditComponent } from '../jcktl-edit/jcktl-tab.component';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
import { JcktlService } from '../_service_jck';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-jckpi37',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
    //Jckpi37DetailComponent,
    //JcktlEditComponent,
    CrudbarComponent,
    //JcktlTabEditComponent,
  ],
  templateUrl: './jckpi37.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Jckpi37Component extends jkSingleComponent implements OnInit {
  override _programId = 'jckpi37';
  constructor() {
    super();
    this.srv = new JcktlService();
    this.uiMode = UiModeType.dialog;  //dialog,tab
    this.title = '易經占卦記錄';
    this.gridInitOpt = { programId: this.programId, sortField: 'TL001', sort: 'desc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = JcktlEditComponent;


    //this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */
  // 客製開始====================================================

}
